<template>
  <div class="container watermark-container">
    <van-nav-bar :title="titleValue"/>
    <!-- 汇总数据区域 -->

    <div
        class="summary-wrap"
        style="
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #ccc;
        border-radius: 4px;
        overflow: hidden;
      "
    >
      <div
          style="flex: 1 1 50%; box-sizing: border-box; border: 1px solid #ddd"
      >
        <van-cell title="当前在途订总单数" :value="summaryData.totalOrders"/>
      </div>
      <div
          style="flex: 1 1 50%; box-sizing: border-box; border: 1px solid #ddd"
      >
        <van-cell
            title="当前应交配件总数"
            :value="summaryData.totalDelivered"
        />
      </div>
      <!-- <div
          style="flex: 1 1 50%; box-sizing: border-box; border: 1px solid #ddd"
      >
        <van-cell title="逾期率" :value="summaryData.overdueRate"/>
      </div> -->
      <!-- <div
        style="flex: 1 1 50%; box-sizing: border-box; border: 1px solid #ddd"
      >
        <van-cell title="供应商等级" :value="summaryData.level" />
      </div> -->
      <div
          style="flex: 1 1 100%; box-sizing: border-box; border: 1px solid #ddd"
      >
        <van-cell title="最近的交期" :value="summaryData.latestDeliveryDate"/>
      </div>
    </div>

    <!--查询表单-->
    <div class="search-div">
      <el-form class="filter-form" label-width="68px" size="small">
        <el-row class="filter-row">
          <!-- 时间类型选择 -->
          <el-col :span="24">
            <!-- <el-form-item label="时间类型" label-width="auto">
              <el-select
                v-model="searchObj.timeType"
                placeholder="请选择时间类型"
                style="width: 60%"
              >
                <el-option label="预期到货时间" :value="1"></el-option>
                <el-option label="创建时间" :value="2"></el-option>
              </el-select>
            </el-form-item> -->

            <!-- 日期范围选择 -->
            <el-form-item :label="searchObj.timeType === 2 ? '下单时间:' : '到货时间:'">
              <div class="date-range-inner">
                <!-- 开始日期 -->
                <el-date-picker
                    v-model="searchObj.startTime"
                    class="primary-filter-control date-control"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择开始日期"
                />

                <!-- 结束日期 -->
                <span class="date-separator">
                  ~
                </span>

                <el-date-picker
                    v-model="searchObj.endTime"
                    class="primary-filter-control date-control"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择结束日期"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="filter-row">
          <el-col :span="24">
            <el-form-item label="合同单号:" class="filter-item">
              <div class="contract-product-inner">
                <el-input
                    class="primary-filter-control"
                    v-model="searchObj.contractNumber"
                    placeholder="如有多个以,隔开"
                ></el-input>

                <div class="inline-product-field">
                  <span class="inline-filter-label">品名:</span>
                  <el-input
                      class="product-filter-control"
                      v-model="searchObj.productName"
                      placeholder="请输入品名"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="filter-row">
          <el-col :span="24">
            <el-form-item label="排序顺序:">
              <el-select
                  v-model="searchObj.sortType"
                  class="primary-filter-control sort-control"
                  placeholder="排序顺序"
              >
                <el-option label="预到货时间" :value="1"></el-option>
                <!-- <el-option label="品名" :value="2"></el-option> -->
                <el-option label="下单时间" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="filter-row">
          <el-col :span="24">
            <el-form-item label="是否修改:">
              <el-select
                  v-model="searchObj.quantityChangeStatus"
                  class="primary-filter-control sort-control"
                  placeholder="是否修改"
              >
                <el-option label="全部" :value="1"></el-option>
                <el-option label="修改" :value="2"></el-option>
                <el-option label="未修改" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="display: flex">
          <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              :loading="loading"
              @click="onRefresh()"
          >搜索
          </el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetData"
          >重置
          </el-button
          >
          <el-button
              type="success"
              icon="el-icon-download"
              size="mini"
              :loading="exportLoading"
              @click="handleExport"
          >
            导出
          </el-button>
        </el-row>
      </el-form>
    </div>

    <el-dialog
        title="导出提示"
        :visible.sync="showExportDialog"
        width="90%"
        :before-close="handleExportCancel"
    >
      <div style="font-size: 14px; line-height: 1.6">
        是否导出当前数据？<br/>
        <span style="color: #999"
        >如无法预览或下载，请点击右上角选择“在浏览器中打开”。</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleExportCancel">取消</el-button>
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="handleExportConfirm"
        >确定导出</el-button
        >
      </span>
    </el-dialog>

    <van-tabs v-model="activeIndex" @click="tabSwitch">
      <van-tab v-for="(item, key) in tabList" :key="key" :title="item.title">
      </van-tab>
    </van-tabs>

    <div class="list-wrap">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
        >
          <van-cell
              v-for="(item, index) in list"
              :key="item.id"
              @click="
              info(
                item.purchaseOrderType,
                item.purchaseOrderId,
                item.contractNumber,
                item.serialNumber,
                item.page
              )
            "
          >
            <template slot="default">
              <div class="item-wrap">
                <div class="item-header">
                  <img
                      src="https://static.dingtalk.com/media/lALOnahFD80CgM0CgA_640_640.png_450x10000q90.jpg"
                      alt=""
                  />
                  <h3
                      style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <span>{{ item.productName }}</span>
                    <!-- 添加序号 -->
                    <span style="color: #666; font-size: 15px">{{
                        index + 1
                      }}</span>
                  </h3>
                </div>

                <div class="item-block">
                  <div class="item-block-content">
                    <div class="item-meta">
                      <div class="item-meta-top">
                        <van-tag
                            v-if="isCreatedToday(item.createTime)"
                            type="success"
                            size="medium"
                        >
                          今日新增
                        </van-tag>
                        <span
                            :style="{
                          color: getRemainingDaysColor(item.remainingDays),
                          fontSize: '14px',
                        }"
                        >
                          {{ getRemainingDaysText(item.remainingDays) }}
                        </span>
                      </div>
                      <div
                          v-if="
                        item.quantityChanged === 1 ||
                        [1, 4, -10].includes(item.reminderStatuses)
                      "
                          class="item-meta-tags"
                      >
                        <van-tag
                            v-if="item.quantityChanged === 1"
                            color="#ffc107"
                            size="medium"
                        >
                          已修改
                        </van-tag>
                        <van-tag
                            v-if="item.reminderStatuses === 1"
                            color="#f39c12"
                            size="medium"
                        >
                          已催单
                        </van-tag>
                        <van-tag
                            v-else-if="item.reminderStatuses === 4"
                            color="#27ae60"
                            size="medium"
                        >
                          已确认
                        </van-tag>
                        <van-tag
                            v-else-if="item.reminderStatuses === -10"
                            color="#3498db"
                            size="medium"
                        >
                          待确认
                        </van-tag>
                      </div>
                    </div>
                    <div class="item-data">
                      <p>合同号：{{ item.contractNumber }}</p>
                      <p>应交数量：{{ item.quantityPurchased }}</p>

                      <p>
                        未交数量：{{
                          item.quantityPurchased - item.quantityDelivered
                        }}
                      </p>
                      <p>
                        预到货日：{{
                          formatExpectedArrivalTime(item.expectedArrivalTime)
                        }}
                      </p>
                      <p>
                        下单时间：{{
                          formatExpectedArrivalTime(item.orderTime)
                        }}
                      </p>
                      <p v-if="item.supplierRemark">
                        反馈：{{ item.supplierRemark }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>

    <div>
      <!-- 弹出框 -->
      <el-dialog
          title="订单详情"
          :visible.sync="dialogVisible"
          width="80%"
          @close="handleClose"
      >
        <!-- 使用 iframe 来嵌套页面 -->
        <iframe
            v-if="iframeVisible"
            :src="iframeSrc"
            width="100%"
            height="500"
            frameborder="0"
        ></iframe>

        <!-- 弹出框底部的操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api/erpVendorIntransitOrders'

import addWatermark from '@/utils/watermark'

export default {
  name: 'process',

  data() {
    return {
      purchaseOrderType: '', // 详情所需参数
      purchaseOrderId: 0,
      contractNumber: '',
      serialNumber: '',
      oldPage: 1, // 详情所在页码
      dialogVisible: false, // 控制弹出框的显示状态
      iframeVisible: true, // 控制 iframe 的显示和销毁

      titleValue: '供应商在途订单列表', // 标题

      list: [],
      loading: false,
      loadingData: false,
      finished: false,
      refreshing: false,
      // 分页请求版本号：切换tab或刷新时递增，用于丢弃迟到的旧请求
      loadVersion: 0,

      // 汇总数据
      summaryData: {
        totalOrders: '', // 总订单数
        totalDelivered: '', // 总产品数
        latestDeliveryDate: '', // 最近一次交期
        level: '', // 等级
        overdueRate: '', //逾期率
        vendorName: '', // 供应商名称
        userName: '', // 用户名称
      },

      pageNo: 1,
      pageSize: 10,
      pages: 1,
      total: 0, // 数据总数
      searchObj: {
        sortType: 1,
        timeType: 1,
        startTime: '',
        endTime: '',
        quantityChangeStatus: 1,
      },
      activeIndex: 0,
      tabList: [{title: '全部'}, {title: '未到期'}, {title: '已到期'}],
      showExportDialog: false, // 控制弹窗显示
      exportLoading: false, // 导出加载状态
    }
  },

  computed: {
    iframeSrc() {
      const timestamp = new Date().getTime() // 获取当前时间戳
      // 使用 window.location.origin 生成完整路径
      const page = this.oldPage // 计算当前页码

      return (
          window.location.origin +
          `/#/supplierShow/${this.purchaseOrderType}/${this.purchaseOrderId}/${this.contractNumber}/${this.serialNumber}?t=${timestamp}&page=${page}`
      )
    },
  },

  created() {
    this.activeIndex = parseInt(this.$route.params.activeIndex)

    // url的query参数
    const {timeType, sortType, startTime, endTime} = this.$route.query

    if (timeType !== undefined) {
      this.searchObj.timeType = Number(timeType)
    }

    if (sortType !== undefined) {
      this.searchObj.sortType = Number(sortType)
    }

    if (startTime !== undefined) {
      this.searchObj.startTime = startTime
    }

    if (endTime !== undefined) {
      this.searchObj.endTime = endTime
    }

    console.log(`路由参数: timeType=${timeType}, sortType=${sortType}, startTime=${startTime}, endTime=${endTime}`)

    this.onLoad()
  },

  mounted() {
    window.addEventListener('message', this.handleMessage)

    // 在途订单 总结
    this.orderSummary()
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },

  methods: {
    // 供应商汇总数据
    orderSummary() {
      api.orderSummary().then((response) => {
        this.summaryData = response.data
        this.titleValue =
            '供应商 ' + this.summaryData.vendorName + '在途订单列表'

        // 调用水印功能
        addWatermark({
          containerSelector: '.watermark-container', // 添加水印的目标容器
          text: this.summaryData.vendorName + ' ' + this.summaryData.userName, // 自定义水印文本
          font: '16px Arial',
          color: 'rgba(0, 0, 0, 0.15)',
          width: 200,
          height: 150,
          angle: -30,
        })
      })
    },

    // 监听详情页的参数
    handleMessage(event) {
      console.log('监听参数:' + event)
      if (event.data.action === 'onLoad') {
        const page = event.data.page // 获取页码
        this.refreshList(page)
      }
    },
    // 刷新某一页的数据
    refreshList(page) {
      // 与分页加载互斥，避免两条请求同时修改list
      if (this.loadingData) return

      this.loadingData = true
      // 记录本次请求版本；期间发生tab切换或刷新时，不再释放新请求的加载状态
      const requestVersion = this.loadVersion
      let promise

      if (this.activeIndex === 0) {
        promise = this.fetchPageInSupplierAll(page)
      } else if (this.activeIndex === 1) {
        promise = this.fetchPageSupplierPendingDeliveryNotOverdueOrders(page)
      } else if (this.activeIndex === 2) {
        promise = this.fetchPageInSupplierExpired(page)
      }

      if (promise) {
        promise.finally(() => {
          if (requestVersion === this.loadVersion) {
            this.loadingData = false
          }
        })
      } else {
        this.loadingData = false
      }

      // 删除从下标 i 开始的所有数据
      this.list.splice(page * this.pageSize)
    },

    tabSwitch() {
      // tab切换后旧请求若晚返回，不能写入新列表
      this.resetListState()
      this.onLoad()
    },

    // 重置分页状态，并让仍在途的旧请求失效
    resetListState() {
      this.loadVersion++
      this.list = []
      this.pageNo = 1
      this.finished = false
      this.loading = false
      this.loadingData = false
    },

    onLoad() {
      // 如果正在加载，直接返回
      if (this.loadingData) return

      this.loadingData = true // 标记为加载状态
      // 请求发出时锁定版本，响应回来后只处理当前列表的数据
      const requestVersion = this.loadVersion

      // // 根据选中的标签，选择不同的请求方法
      // switch (this.activeIndex) {
      //   case 0:
      //     return this.pageInSupplierAll() // 异步调用
      //   case 1:
      //     return this.pageSupplierPendingDeliveryNotOverdueOrders()
      //   case 2:
      //     return this.pageInSupplierExpired()
      //   default:
      //     return Promise.resolve()
      // }
      let promise
      switch (this.activeIndex) {
        case 0:
          promise = this.pageInSupplierAll()
          break
        case 1:
          promise = this.pageSupplierPendingDeliveryNotOverdueOrders()
          break
        case 2:
          promise = this.pageInSupplierExpired()
          break
        default:
          promise = Promise.resolve()
      }

      // 确保 modifyTitle() 运行
      promise.then(() => {
        if (requestVersion === this.loadVersion) {
          this.modifyTitle()
        }
      })
      return promise
    },

    // 修改标题
    modifyTitle() {
      this.tabList = [
        {title: '全部'},
        {title: '未到期'},
        {title: '已到期'},
      ]
      let index = this.activeIndex
      let oldTitle = this.tabList[index].title
      this.tabList[index].title = oldTitle + '(' + this.total + ')'
    },

    resetData() {
      this.searchObj = {
        sortType: 1,
        timeType: 1,
        quantityChangeStatus: 1,
      }

      this.onRefresh()
    },

    // 刷新
    onRefresh() {
      this.resetListState()
      return this.onLoad()
    },

    // 根据剩余天数返回对应的颜色
    getRemainingDaysColor(remainingDays) {
      if (remainingDays < 0) {
        return 'red' // 小于0时，红色
      } else if (remainingDays <= 3) {
        return 'orange' // 小于等于3且大于等于0时，橙色
      } else if (remainingDays <= 7) {
        return '#ffc639' // 小于等于7时，暖橙色
      } else {
        return 'green' // 大于7时，绿色
      }
    },

    getRemainingDaysText(remainingDays) {
      return remainingDays < 0
          ? `已逾期 ${Math.abs(remainingDays)} 天`
          : `剩余时间：${remainingDays} 天`
    },

    formatExpectedArrivalTime(value) {
      if (!value) {
        return value
      }

      const dateText = String(value)
      if (!/^\d{8}$/.test(dateText)) {
        return value
      }

      const year = dateText.slice(0, 4)
      const month = Number(dateText.slice(4, 6))
      const day = Number(dateText.slice(6, 8))

      if (!month || !day) {
        return value
      }

      return `${year}年${month}月${day}日`
    },

    // 判断创建时间是否为浏览器本地日期的今天
    isCreatedToday(createTime) {
      if (!createTime) {
        return false
      }

      const normalizedCreateTime = String(createTime)
          .replace(/\D/g, '')
          .slice(0, 8)

      if (normalizedCreateTime.length !== 8) {
        return false
      }

      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')

      return normalizedCreateTime === `${year}${month}${day}`
    },

    // 统一处理三个tab的分页响应，保证分页状态和去重逻辑一致
    applyPageResponse(response, pageNo) {
      const pageData = response.data || {}
      const records = pageData.records || []

      // 下拉刷新时以本次返回为准，先清掉旧列表再合并
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }

      this.mergeRecords(records, pageNo)
      this.pages = pageData.pages || 1
      if (pageNo === 1) {
        this.total = pageData.total
      }

      this.loading = false
      this.finished = pageNo >= this.pages
      this.pageNo = pageNo + 1
      this.loadingData = false
    },

    // 按订单id合并数据：已存在的更新原位置，不存在的追加，防止跨页重复展示
    mergeRecords(records, pageNo) {
      const recordsById = new Map()

      this.list.forEach((item) => {
        if (item && item.id !== undefined && item.id !== null) {
          recordsById.set(String(item.id), item)
        }
      })

      records.forEach((record) => {
        if (!record) {
          return
        }

        // 没有id的数据无法判重，保留原逻辑直接追加
        if (record.id === undefined || record.id === null) {
          this.list.push(Object.assign({}, record, {page: pageNo}))
          return
        }

        const key = String(record.id)
        const existingItem = recordsById.get(key)

        if (existingItem) {
          // 用接口返回的最新内容更新已有订单，保持其原展示位置不变
          const mergedItem = Object.assign({}, existingItem, record, {
            page: pageNo,
          })
          this.list.splice(this.list.indexOf(existingItem), 1, mergedItem)
          recordsById.set(key, mergedItem)
          return
        }

        const newItem = Object.assign({}, record, {page: pageNo})
        this.list.push(newItem)
        recordsById.set(key, newItem)
      })
    },

    pageInSupplierAll() {
      const pageNo = this.pageNo
      const requestVersion = this.loadVersion

      return api
          .pageInSupplierAll(pageNo, this.pageSize, this.searchObj)
          .then((response) => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.applyPageResponse(response, pageNo)
          })
          .catch(() => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.loading = false
            this.loadingData = false
          })
    },
    fetchPageInSupplierAll(page) {
      const requestVersion = this.loadVersion

      return api
          .pageInSupplierAll(page, this.pageSize, this.searchObj)
          .then((response) => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.mergeRecords(response.data.records || [], page)
          })
          .catch(() => {})
    },

    // 查看未完成未到期订单
    pageSupplierPendingDeliveryNotOverdueOrders() {
      const pageNo = this.pageNo
      const requestVersion = this.loadVersion

      return api
          .pageSupplierPendingDeliveryNotOverdueOrders(
              pageNo,
              this.pageSize,
              this.searchObj
          )
          .then((response) => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.applyPageResponse(response, pageNo)
          })
          .catch(() => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.loading = false
            this.loadingData = false
          })
    },
    fetchPageSupplierPendingDeliveryNotOverdueOrders(page) {
      const requestVersion = this.loadVersion

      return api
          .pageSupplierPendingDeliveryNotOverdueOrders(
              page,
              this.pageSize,
              this.searchObj
          )
          .then((response) => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.mergeRecords(response.data.records || [], page)
          })
          .catch(() => {})
    },

    pageInSupplierExpired() {
      const pageNo = this.pageNo
      const requestVersion = this.loadVersion

      return api
          .pageInSupplierExpired(pageNo, this.pageSize, this.searchObj)
          .then((response) => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.applyPageResponse(response, pageNo)
          })
          .catch(() => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.loading = false
            this.loadingData = false
          })
    },

    fetchPageInSupplierExpired(page) {
      const requestVersion = this.loadVersion

      return api
          .pageInSupplierExpired(page, this.pageSize, this.searchObj)
          .then((response) => {
            if (requestVersion !== this.loadVersion) {
              return
            }

            this.mergeRecords(response.data.records || [], page)
          })
          .catch(() => {})
    },

    info(
        purchaseOrderType,
        purchaseOrderId,
        contractNumber,
        serialNumber,
        oldPage
    ) {
      // 查询所需参数
      this.purchaseOrderType = purchaseOrderType
      this.purchaseOrderId = purchaseOrderId
      this.contractNumber = contractNumber
      this.serialNumber = serialNumber

      // 记录原本页码
      this.oldPage = oldPage
      this.dialogVisible = true

      this.iframeVisible = false // 销毁 iframe
      this.$nextTick(() => {
        this.iframeVisible = true // 重新显示 iframe
      })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.purchaseOrderType = ''
      this.purchaseOrderId = 0
      this.contractNumber = ''
      this.serialNumber = ''
      this.oldPage = 1
    },

    // 用户点击“导出”按钮时
    handleExport() {
      this.showExportDialog = true
    },
    // 用户点击弹窗的“取消”
    handleExportCancel() {
      this.showExportDialog = false
    },
    // 用户点击弹窗的“确定”
    async handleExportConfirm() {
      this.exportLoading = true
      try {
        const params = {
          ...this.searchObj,
          selectType: this.activeIndex,
        }
        const res = await api.getSupplierExcel(params)
        const fileUrl = res.data

        const a = document.createElement('a')
        a.href = fileUrl
        a.download = fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
        this.showExportDialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .van-nav-bar {
  background: #1d1e20;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

.container {
  padding-bottom: 50px;

  .search-div {
    margin: 6px 0;
    padding: 8px 8px 10px;
    background: #f7f8fa;
    border-top: 1px solid #edf0f5;
    border-bottom: 1px solid #edf0f5;

    .filter-row {
      margin-bottom: 8px;
    }

    .filter-form {
      /deep/ .el-form-item {
        margin-bottom: 0;
      }

      /deep/ .el-form-item__label {
        padding-right: 6px;
        color: #5f6673;
        font-size: 13px;
        line-height: 32px;
      }

      /deep/ .el-form-item__content {
        line-height: 32px;
      }

      /deep/ .el-input__inner {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
      }

      .date-range-inner {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .date-control {
        flex: 0 0 calc((100% - 20px) / 2);
      }

      .date-separator {
        flex: 0 0 20px;
        color: #5f6673;
        text-align: center;
      }

      .filter-item {
        white-space: nowrap;
      }

      .primary-filter-control {
        width: calc((100% - 20px) / 2);
      }

      .contract-product-inner {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .inline-product-field {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
        margin-left: 8px;
      }

      .inline-filter-label {
        flex: 0 0 38px;
        color: #5f6673;
        font-size: 13px;
        line-height: 32px;
        text-align: right;
        padding-right: 6px;
      }

      .product-filter-control {
        flex: 1;
        min-width: 0;
      }
    }
  }

  .list-wrap {
    margin-top: 4px;
    border-top: 1px solid #ebedf0;
  }

  .item-wrap {
    font-size: 12px;
    color: #a7a8a9;

    .item-header {
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        margin-right: 4px;
      }

      h3 {
        flex: 1;
        font-size: 15px;
        color: #000;
        padding: 0;
        margin: 0;
      }
    }

    .item-block {
      padding: 4px 0;
      border: 1px solid #ddd; /* 添加边框，提升视觉分隔 */
      font-size: 14px;

      .item-meta-top {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > * + * {
          margin-left: 4px;
        }
      }

      .item-block-content {
        &::after {
          content: '';
          display: block;
          clear: both;
        }
      }

      .item-data {
        overflow-wrap: break-word;
      }

      .item-meta {
        float: right;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-left: 10px;
      }

      .item-meta-tags {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-top: 4px;

        > * + * {
          margin-top: 4px;
        }
      }

      p {
        padding: 0;
        margin: 5px 0;
        color: #000;
        line-height: 20px;
      }
    }

    .item-status {
      .pass {
        color: #4cb971;
      }

      .refused {
        color: #eb8473;
      }
    }

    .summary-wrap {
      margin-bottom: 10px;
      background-color: #f7f8fa;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>
